import { constants } from '../utils/constants'

function addressesURL(branch) {
  const URL = `https://raw.githubusercontent.com/lloydgalley/dpos-chain-spec/master/contracts.json`
  return URL
}

function ABIURL(branch, contract) {
  const URL = `https://raw.githubusercontent.com/lloydgalley/dpos-chain-spec/master/abis/${
    constants.ABIsSources[contract]
  }`
  return URL
}

function getABI(branch, contract) {
  let addr = helpers.ABIURL(branch, contract)
  return fetch(addr).then(function(response) {
    return response.json()
  })
}

const helpers = {
  addressesURL,
  ABIURL,
  getABI
}

export default helpers
